import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectBundleDO } from '../../../../../../system/system-dtos';
import { EntityGroupDetailsService } from '../../../../../views/entity-group/entity-group-details/entity-group-details.service';
import { isDefined } from '../../../../../utils/utils';

interface OddsDO {
  o: string;
  v: number;
}

interface MoneyLine {
  sportId: string;
  leagueId: string;
  eventId: string;
  source: string;
  period: string;
  home: OddsDO;
  away: OddsDO;
  draw: OddsDO;
  dateCreated: Date;
  dateUpdated: Date;
}

interface MoneyLineByPeriod {
  period: string;
  lines: MoneyLine[];
}

@Component({
  selector: 'app-form-field-betslip',
  templateUrl: './betslip-form-field.component.html',
  styleUrls: ['./betslip-form-field.component.scss'],
  standalone: false,
})
export class BetslipFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  selected: SelectBundleDO;

  bundles: SelectBundleDO[] = [];

  bundleData: any;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  bundleId: any;

  hasFormData: boolean = false;

  linesByPeriod: MoneyLineByPeriod[];

  constructor(private entityGroupService: EntityGroupDetailsService) {
    super();
  }

  ngOnInit() {
    if (isDefined(this.data)) {
      this.linesByPeriod = this.data;
    }
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnDestroy() {}
}
